import styled from "styled-components";
import { breakpoints } from "theme/themes";

const LearnMoreFlex = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  padding: 2rem 1rem;
  color: ${(props) => props.textColor};
  background-color: ${(props) => props.backgroundColor};

  @media ${breakpoints.medium} {
    padding: 3rem 2rem;
  }

  @media ${breakpoints.larger} {
    flex-direction: row;
    padding: 5rem 5.625rem;
  }

  @media ${breakpoints.xl4} {
    flex-direction: row;
    padding: 5rem 200px;
  }

  .learnmore-title {
    width: 100%;
    font-size: 22px;
    font-family: ${({ theme }) => theme.fonts.fontHeavy};
    margin-bottom: 1rem;

    @media ${breakpoints.larger} {
      width: 35%;
      font-size: 26px;
      padding-right: 6rem;
    }


    @media ${breakpoints.xl3} {
      font-size: 30px;
    }

  }

  .learnmore-content {
    width: 100%;
    font-size: 16px;
    line-height: 1.45;
    font-family: ${({ theme }) => theme.fonts.fontMedium};

    @media ${breakpoints.larger} {
      width: 65%;
      font-size: 20px;
    }
  }

  p:not(:last-of-type) {
    margin-bottom: 1rem;
  }

  a {
      text-decoration: underline;
      font-family: ${({ theme }) => theme.fonts.fontHeavy};
      text-decoration-thickness: 3px; 
      text-underline-position: under;
      text-decoration-color: ${(props) => props.linkUnderlineColor};
  }

  a + br {
    content: '';
    display: block;
    margin: 16px 0;
  }
`;

export default LearnMoreFlex;
